import React, { Fragment, useEffect } from "react";
import "./DeliveryList.css";
import IconButton from '@material-ui/core/IconButton';
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import VisibilityIcon from '@material-ui/icons/Visibility';
import NotificationIcon from "../../common/components/NotificationIcon";
import { get } from "lodash";
import { Tooltip } from "@material-ui/core";
import FullscreenLoader from "../../common/components/FullscreenLoader";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import moment from "moment-timezone";
import { Redirect } from "react-router-dom";
import TablePagination from '@material-ui/core/TablePagination';
import { setPageNumber } from "../../store/actions/orderHistory.actions";
import { selectedViewDelivery } from "../../store/actions/delivery.actions";
import { deliveryService } from "../../services/delivery.service";
import { Prompt } from "react-router";
import ViewDelivery from "./ViewDelivery";
import { useState } from "react";
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import { getBillingDetails } from "../../store/actions/delivery.actions";
import { createOrgIdBrandsMappingReverse } from "../../common/components/util";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import Grid from '@material-ui/core/Grid';
import Paper from "@material-ui/core/Paper";
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  bodyContent: {
    color: '#666666',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito'
  },
  tableHead: {
    color: '#133F8A',
    fontWeight: 900,
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    minWidth: 100
  },
  tableHeadChildRow: {
    color: '#25272bff',
    fontWeight: 700,
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    minWidth: 100
  },
  actionButton: {
    color: '#1A9FE0',
  },
}));

const columns = [
  {
    id: 'delivery',
    label: 'Delivery No.',
    align: 'left',
  },
  {
    id: 'salesDocument',
    label: 'Order No.',
    align: 'left'
  },
  {
    id: 'description',
    label: 'Description',
    align: 'left'
  },
  {
    id: 'billingStatus',
    label: 'Billing Status',
    align: 'left'
  },
  {
    id: 'goodsMovementStatus',
    label: 'Goods Movement Status',
    align: 'left'
  },
  {
    id: 'shippingPlanningStatus',
    label: 'Shipping Planning Status',
    align: 'left'
  },
  {
    id: 'shippingReceivingPoint',
    label: 'Shipping Receiving Point',
    align: 'left'
  },
  {
    id: 'pickingStatus',
    label: 'Picking Status',
    align: 'left'
  },
];

const DeliveryList: React.FC = () => {
  const history = useHistory()
  const classes = useStyles();
  const dispatch = useDispatch();
  const rowsPerPage = 10;
  const [page, setPage] = React.useState(0);
  const [prompt, setPromt] = useState(false);
  const [deliveryData, setDeliveryData] = React.useState<any>();
  const [len, setLen] = React.useState<any>();
  const [delivery, setDeliveryList] = React.useState<any>([]);
  const [download, setDownloadInvoice] = React.useState<any>([]);
  const [open, setOpen] = React.useState<any>(false);
  const [make, setMake] = React.useState<any>("")
  const [errorMessage, setErrorMessage] = React.useState<any>("")
  const { deliveryList, viewDeliverySelected }: any = useSelector((state: any) => state.delivery);
  const { viewDelivery, billingDetails }: any = useSelector((state: any) => state.delivery);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const [orderCreatedOnDate, setOrderCreatedOnDate] = React.useState<any>();
  const Username: any = sessionStorage.getItem("userRoleCreatedBy");
  const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
  const [loading, setLoading] = React.useState<any>(false);
  const isFSE = (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre');
  const orgIdBrandsMapping: any = {
    "Toyota": "2001",
    "Honda": "2002",
    "BYD": "2092",
    "Famco": "2003",
    "TE": "2380",
    "OES": "2195",
  }


  const shouldShowViewInvoiceButton = () => {
    const customerTierType = sessionStorage.getItem('customerTierType');
    const userType = sessionStorage.getItem('userType');
    const isFSE = userType === 'FSE' || userType === 'sre';

    const customerTierTypeFromAPI = profileDetails?.data?.data?.customerInfo?.customerTierType;

    const isIBUser =
      customerTierType === 'Int. Business' || customerTierType === 'intbusiness' ||
      customerTierTypeFromAPI === 'Int. Business' || customerTierTypeFromAPI === 'intbusiness';

    const orderCreatedFor = (
      viewDelivery?.data?.parentOrder?.salesData?.orderCreatedFor ||
      viewDelivery?.data?.salesData?.orderCreatedFor
    )?.toString().trim().toUpperCase();
    const isMultiAutoOrder = orderCreatedFor === 'MA';

    const orderOrgId =
      viewDelivery?.data?.orgid ||
      viewDelivery?.data?.parentOrder?.orgid ||
      viewDelivery?.data?.parentOrder?.subEnquiries?.[0]?.orgid ||
      sessionStorage.getItem('selectedOrderOrgId');

    const hasOrgId = orderOrgId !== undefined && orderOrgId !== null && orderOrgId?.toString().trim() !== '';
    const isArchAutoOrder = hasOrgId
      ? orderOrgId?.toString().trim() === '2428'
      : orderCreatedFor === 'AA';

    console.log('DEBUG shouldShowViewInvoiceButton ENTRY', {
      customerTierType, userType, customerTierTypeFromAPI, isIBUser, isMultiAutoOrder, orderOrgId, hasOrgId, orderCreatedFor, isArchAutoOrder,
    });

    if (isIBUser || isMultiAutoOrder) {
      if (isFSE) {
        console.log('DEBUG DeliveryList IB/MA FSE orgid check', { orderOrgId, hasOrgId, orderCreatedFor, isArchAutoOrder });
        return isArchAutoOrder === true;
      } else {
        const isSalesReturnAccess = profileDetails?.data?.data?.customerInfo?.isSalesReturnAccess;
        console.log('DEBUG DeliveryList IB/MA Customer check', { orderOrgId, hasOrgId, orderCreatedFor, isArchAutoOrder, isSalesReturnAccess });
        return isSalesReturnAccess === true && isArchAutoOrder === true;
      }
    }

    if (isFSE) {
      return true;
    }

    const isSalesReturnAccess = profileDetails?.data?.data?.customerInfo?.isSalesReturnAccess;
    return isSalesReturnAccess === true;
  };

  const { brandsList }: any = useSelector((state: any) => state.dealer);
  const orgIdBrandsMappingReverse = createOrgIdBrandsMappingReverse(brandsList?.data);

  const [expandedRows, setExpandedRows] = React.useState<{ [key: number]: boolean }>({});
  const [expandedRow, setExpandedRow] = React.useState<number | null>(null);

  useEffect(() => {
    let count = 0
    viewDelivery && viewDelivery.data && viewDelivery.data.parentOrder && viewDelivery.data.parentOrder && viewDelivery.data.parentOrder.subEnquiries.map((ele: any) => {
      if (ele.status !== "Not delivered") {
        count += 1
      }
    })
    setLen(count)
  }, [ViewDelivery])

  useEffect(() => {
    const deliveryData = get(deliveryList, 'data.data.deliveryList', {})[0];
    setMake(viewDeliverySelected && viewDeliverySelected.data && viewDeliverySelected.data.make)
    if (deliveryList && deliveryList.data && deliveryList.data.data && deliveryList.data.data) {
      setDeliveryList(deliveryList && deliveryList.data && deliveryList.data.data && deliveryList.data.data)
    }
  }, [deliveryList, viewDeliverySelected])

  const toggleExpand = (index: number) => {
    setExpandedRows((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  let customerName: any =
    delivery?.customerName ||
    delivery?.[0]?.customerName ||
    "";

  // dynamic payload creation for View Invoice
  const getInvoiceDetails = async (data: any) => {
    setLoading(true);
    const sessionDetails = {
      webApplicationLoginId: webApplicationLoginId,
      clientIPAddress: sessionStorage.getItem('clientIp'),
    };

    const payload = {
      sapCustomerId: data?.sapCustomerId || "",
      customerName: isFSE ? customerName : sessionStorage.getItem('customerName'),
      invoiceNumber: data?.billingDocument || "",
      orderNumber: data?.salesDocument || "",
      enquiryNumber: viewDelivery?.data?.enquiryNumber || "",
      sessionDetails,
      // orgId: orgIdBrandsMapping[data?.make] || "",
      orgId: viewDelivery?.data?.orgid || "",
      make: data?.make || "",
    };

    let responseData: any = await dispatch(getBillingDetails(payload))
    if (responseData && responseData.status === 400) {
      setOpenErrorSnackbar(true);
      handleopenCloseSnackbar(true);
      setSuccessMessage(responseData && responseData.error);
      setLoading(false);
    } else {
      setOpenErrorSnackbar(false);
      handleopenCloseSnackbar(true);
      setSuccessMessage(responseData && responseData.message && responseData.message.message);
      setLoading(false);
    }
  };


  // Grouping deliveries by invoice
  const groupedDeliveries = delivery.reduce((acc: any[], item: any) => {
    const invoiceKey = item.billingDocument || 'NO_INVOICE';
    const existing = acc.find((g) => g.invoiceNo === invoiceKey);

    const deliveryObj = {
      deliveryNo: item.delivery,
      status: item.status,
      make: viewDelivery?.data?.make,
      enquiryNumber: viewDelivery?.data?.enquiryNumber,
    };

    if (existing) {
      existing.deliveries.push(deliveryObj);
    } else {
      acc.push({
        invoiceNo: invoiceKey,
        invoiceDate: viewDelivery?.data?.parentOrder?.createdOn,
        lines: item?.lines || 1,
        status: item.status,
        deliveries: [deliveryObj],
      });
    }

    return acc;
  }, []);

  const getDeliveryNumber = (no: any) => {
    if (deliveryData) {
      if (deliveryData.enquiryNumber === no) {
        return deliveryData.delivery
      }
    }
  }

  const getInvoiceNo = (no: any) => {
    if (deliveryData) {
      if (deliveryData.enquiryNumber === no) {
        return deliveryData.billingDocument
      }
    }
  }
  const handleopenClose = () => {
    setOpen(false)
  }


  const exportData = async (no: any, data: any) => {

    const res = await deliveryService.downloadInvoice(no, orgIdBrandsMappingReverse[make]);

    setDownloadInvoice(res);
    if (res.success === false) {
      setOpen(true)
      setErrorMessage(res.error)
      setShowErrorMessage(res.error || (res && res.message && res.message.message) || "Something went wrong")
      handleopenCloseErrorSnackbar(true)
    } else if (res && res.message && res.message.status === "S") {
      window.open(res && res.data && res.data.url)
    }
  }

  const handlePageChange = () => {

  }

  const handleredirect = (enquiryNumber: any, deliveryNo: any, make: any, orgId: any, sapCustomerId: any) => {
    sessionStorage.setItem("selectedOrderMake", make);
    sessionStorage.setItem("selectedOrderOrgId", orgId);
    sessionStorage.setItem("selectedOrderEnquiryNumber", enquiryNumber);
    sessionStorage.setItem("selectedSapCustomerId", sapCustomerId || '');

    dispatch(selectedViewDelivery({
      enquiryNumber,
      make,
      orgId,
      deliveryNo
    }));

    history.push({ pathname: "/deliverydetails" });
  }

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  return (
    <Fragment>
      {loading && <FullscreenLoader />}
      <Snackbar
        open={openSnackbar}
        message={successMessage}
        handleopenClose={() => {
          handleopenCloseSnackbar(false)
        }} />
      <Snackbar
        open={openErrorSnackbar}
        type="error"
        message={showErrorMessage}
        handleopenClose={() => {
          handleopenCloseErrorSnackbar(false)
        }} />
      {deliveryList && deliveryList.loading ? <FullscreenLoader /> : <div>
        {/* ── Page Header ── */}
        <div className="d-flex align-items-center">
          <h2 className="page-title">
            Delivery & Invoice List
            <Breadcrumbs>
              <Typography color="textSecondary" className="breadcrumb-text-order-history">Order History</Typography>
              <Typography color="textPrimary" className="breadcrumb-text-delivery-details">Delivery List</Typography>
            </Breadcrumbs>
          </h2>
          <div className="ml-auto">
            <AnnouncementIcon />
            <NotificationIcon />
          </div>
        </div>

        {/* ── Sub-header + Back to List — rendered ONCE ── */}
        <div className="row mt-4">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="d-flex align-items-center">
              <h5 className="page-sub-title">Delivery Details</h5>
              <IconButton className={`ml-auto ${classes.actionButton}`} onClick={() => { history.push(`/orderhistory`); sessionStorage.setItem('userRoleCreatedBy', ""); }}>
                <ChevronLeftIcon fontSize="small" />
                <span className="backLinkLabel">Back to List</span>
              </IconButton>
            </div>
          </div>
        </div>

        {/* ── Empty State ── */}
        {delivery.length === 0 &&
          <div className="col-lg-12 col-md-12 col-sm-12 text-center">
            <h4>
              No Invoice(s) generated
            </h4>
          </div>
        }

        {/* ── All content when deliveries exist — rendered ONCE ── */}
        {delivery.length >= 1 &&
          <>
            {/* Order Info Card — rendered ONCE */}
            <div className="row">
              <div className="col-12">
                <div className="card p-4 shadow-sm rounded" style={{ background: "#fff" }}>
                  {(() => {
                    const data = delivery[0];
                    const ele = viewDelivery?.data;
                    return (
                      <div className="d-flex flex-wrap align-items-center gap-4">

                        {/* Order Enquiry No */}
                        <div className="d-flex align-items-center gap-1 px-3 pr-3">
                          <strong>Order Enquiry No:</strong>
                          <span
                            className="text-primary cursor-pointer px-3"
                            onClick={() => {
                              sessionStorage.setItem("enquiryModeDetails", JSON.stringify({
                                mode: "view",
                                masterId: ele?.parentOrder?.masterId,
                                orderType: "order",
                                quotation: false
                              }));
                              dispatch(setPageNumber(page));
                              history.push("/viewenquiry");
                            }}
                          >
                            <ins>{ele?.parentOrder?.masterId || "-"}</ins>
                          </span>
                        </div>

                        {/* Reference No */}
                        <div className="d-flex align-items-center gap-1 px-3 pr-3">
                          <strong>Reference No.:</strong>
                          <span className="px-3">{ele?.enquiryReferenceNumber || "-"}</span>
                        </div>

                        {/* Order No */}
                        <div className="d-flex align-items-center gap-1 px-3 pr-3">
                          <strong>Order No.:</strong>
                          <span className="px-3">
                            {data?.salesDocument || viewDelivery?.data?.backOrderNumber || "-"}
                          </span>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>

            {/* Section Title + Return instruction */}
            <div className="row mt-4">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="page-sub-title">
                    List of Deliveries / Invoices
                  </h5>

                  {shouldShowViewInvoiceButton() && (
                    <div className="page-sub-title">
                      To raise a Return, click on below{" "}
                      <IconButton
                        size="small"
                        style={{ color: "#1A9FE0", pointerEvents: "none", cursor: "default" }}
                      >
                        <OpenInNewOutlinedIcon fontSize="inherit" />
                      </IconButton>{" "}
                      icon.
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Invoice Table — rendered ONCE */}
            <div className="row">
              <div className="col-12">
                <div className="cardCommon orderItems">
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ padding: '3px 6px', width: '32px' }}></TableCell>
                          <TableCell className={classes.tableHead}>Invoice No.</TableCell>
                          <TableCell className={classes.tableHead}>Invoice Date</TableCell>
                          <TableCell className={classes.tableHead}>Lines</TableCell>
                          <TableCell className={classes.tableHead}>Status</TableCell>
                          <TableCell className={classes.tableHead}>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {delivery.map((data: any, index: any) => {
                          const ele = viewDelivery?.data;
                          const isOpen = expandedRow === index;
                          const hasInvoice = data.billingDocument && data.billingDocument !== "";

                          return (
                            <React.Fragment key={index}>
                              <TableRow>
                                <TableCell style={{ padding: '3px 6px', width: '32px' }}>
                                  <IconButton size="small" onClick={() => setExpandedRow(isOpen ? null : index)}>
                                    {isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                                  </IconButton>
                                </TableCell>
                                <TableCell>{data.billingDocument || "-"}</TableCell>

                                <TableCell>
                                  {ele?.parentOrder?.createdOn
                                    ? moment(ele.parentOrder.createdOn).utc().format("DD MMM YYYY")
                                    : "-"}
                                </TableCell>

                                <TableCell>{data.lines || "-"}</TableCell>
                                <TableCell>{ele?.status || "-"}</TableCell>

                                <TableCell>
                                  {/* Download Invoice Button */}
                                  {!(profileDetails?.data?.data?.accessParameter?.featureAccessibility?.find(
                                    (feature: { featureCode: string; value: boolean; label: string }) => feature.featureCode === 'DOWNLOAD_INVOICE'
                                  )?.value === false) && (
                                      <Tooltip title={!hasInvoice ? "Invoice no. is not generated" : "Download Invoice"} placement="top">
                                        <span>
                                          <IconButton
                                            className="exportExcel"
                                            size="small"
                                            disabled={!hasInvoice}
                                            onClick={() => {
                                              if (hasInvoice) {
                                                let checkDate = viewDelivery.data && viewDelivery.data.parentOrder && viewDelivery.data.parentOrder.createdOn
                                                setOrderCreatedOnDate(checkDate);

                                                let restrictFromDate = new Date("2022-11-22T00:00:00Z");
                                                checkDate = new Date(checkDate);
                                                if (checkDate > restrictFromDate) {
                                                  exportData(data.billingDocument, ele)
                                                } else {
                                                  exportData(data.salesDocument, ele)
                                                }
                                              }
                                            }}
                                          >
                                            <InsertDriveFileIcon fontSize="inherit" />
                                          </IconButton>
                                        </span>
                                      </Tooltip>
                                    )}

                                  {/* View Invoice Details Button - Always visible, click action conditional */}
                                  {shouldShowViewInvoiceButton() && (
                                    <Tooltip
                                      title={!hasInvoice ? "Invoice no. is not generated" : "Request a Return"}
                                      placement="top"
                                    >
                                      <span>
                                        <IconButton
                                          size="small"
                                          className={classes.actionButton}
                                          disabled={!hasInvoice}
                                          onClick={() => {
                                            if (hasInvoice) {
                                              sessionStorage.setItem("searchByInvoice", "false");
                                              handleredirect(
                                                ele?.enquiryNumber,
                                                data?.delivery,
                                                ele?.make,
                                                ele?.orgid,
                                                data?.sapCustomerId
                                              );
                                              getInvoiceDetails({ ...data, make: ele.make, sapCustomerId: data.sapCustomerId });
                                              sessionStorage.setItem("InoviceDate", (ele?.parentOrder?.createdOn
                                                ? moment(ele.parentOrder.createdOn).utc().format("DD MMM YYYY")
                                                : "-"));
                                              history.push("/viewinvoice");
                                            }
                                          }}
                                        >
                                          <OpenInNewOutlinedIcon fontSize="inherit" />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                  )}
                                </TableCell>
                              </TableRow>

                              {isOpen && (
                                <TableRow>
                                  <TableCell colSpan={6} className="bg-light p-0">
                                    <Table size="small">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell style={{ padding: '4px 8px', width: '32px' }}></TableCell>
                                          <TableCell className={classes.tableHeadChildRow}>Delivery No.</TableCell>
                                          <TableCell className={classes.tableHeadChildRow}>Status</TableCell>
                                          <TableCell className={classes.tableHeadChildRow}></TableCell>
                                          <TableCell className={classes.tableHeadChildRow}></TableCell>
                                          <TableCell className={classes.tableHeadChildRow}>Action</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {Array.isArray(data.deliveryItem) && data.deliveryItem.length > 0 ? (
                                          data.deliveryItem.map((item: any, childIndex: any) => (
                                            <TableRow key={childIndex}>
                                              <TableCell></TableCell>
                                              <TableCell>{item.delivery || "-"}</TableCell>
                                              <TableCell>{ele?.status || "-"}</TableCell>
                                              <TableCell></TableCell>
                                              <TableCell></TableCell>
                                              <TableCell>
                                                <Tooltip title="View Delivery Details" placement="top">
                                                  <IconButton
                                                    size="small"
                                                    className={classes.actionButton}
                                                    onClick={() => {
                                                      handleredirect(
                                                        ele?.enquiryNumber,
                                                        item?.delivery,
                                                        ele?.make,
                                                        ele?.orgid,
                                                        data?.sapCustomerId
                                                      );
                                                    }}
                                                  >
                                                    <VisibilityIcon fontSize="inherit" />
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                            </TableRow>
                                          ))
                                        ) : (
                                          <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>{data.delivery || "-"}</TableCell>
                                            <TableCell>{ele?.status || "-"}</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>
                                              <Tooltip title="View Delivery Details" placement="top">
                                                <IconButton
                                                  size="small"
                                                  className={classes.actionButton}
                                                  disabled={sessionStorage.getItem('customerTierType') === "Int. Business"}
                                                  onClick={() => {
                                                    handleredirect(
                                                      ele?.enquiryNumber,
                                                      data?.delivery,
                                                      ele?.make,
                                                      ele?.orgid,
                                                      data?.sapCustomerId
                                                    );
                                                  }}
                                                // sessionStorage.setItem("selectedDelivery", index);
                                                // sessionStorage.setItem("selectedOrderMake", ele.make);
                                                // dispatch(
                                                //   selectedViewDelivery({
                                                //     enquiryNumber: ele.enquiryNumber,
                                                //     make: ele.make,
                                                //     deliveryNo: data.delivery
                                                //   })
                                                // );
                                                // }}
                                                >
                                                  <VisibilityIcon fontSize="inherit" />
                                                </IconButton>
                                              </Tooltip>
                                            </TableCell>
                                          </TableRow>
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <div className="col-12 d-flex justify-content-end">
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      component="div"
                      count={delivery.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        <Prompt when={prompt} message={"By Refreshing data will be lost are u sure"}></Prompt>
      </div>

      }
    </Fragment >
  );
};

export default DeliveryList;